/**
 * Saves a fetched blob as a file. Used for API downloads that need the bearer token (a plain
 * `<a href>` to `/api/...` would go out unauthenticated and get a 401).
 *
 * An object-URL download link (the native SwiftUI app has its own Quick Look / share sheet).
 */
export function saveBlob(blob: Blob, fileName: string): Promise<void> {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  a.rel = 'noopener';
  a.click();
  // Revoke after the click has been handed to the browser; an immediate revoke can cancel the save in Safari.
  setTimeout(() => URL.revokeObjectURL(url), 1000);
  return Promise.resolve();
}

/** A download file name for a document title: PDFs are the only allowed type, so ensure the extension. */
export function pdfFileName(title: string): string {
  const name = title.trim() || 'dokument';
  return name.toLowerCase().endsWith('.pdf') ? name : `${name}.pdf`;
}
